import React, { useEffect, useState } from "react";
import leftIcon from "../../assets/Icons/leftArrow.svg";
import Logo from "../../assets/Icons/Frame 476.png";
import { Link, useNavigate } from "react-router-dom";
import "../../styles/Login.scss";
import OTPInput from "react-otp-input";
import { useSelector } from "react-redux";
import { isLoading } from "../../redux/selectors/authSelector";
import check from "../../assets/gifs/check.gif";
import { useCountryNavigate } from "./UseCountryNavigate";

const SuccessfullCard = ({ title, btnName, subTitle, type }) => {
  // const navigate = useNavigate();
  const navigate = useCountryNavigate();
  const [mobile_otp, setOtp] = useState("");
  const [remainingTime, setRemainingTime] = useState(59);
  const [isResendEnabled, setIsResendEnabled] = useState(false);
  const loader = useSelector(isLoading);

  useEffect(() => {
    let timerInterval;
    if (remainingTime > 0) {
      timerInterval = setInterval(() => {
        setRemainingTime((prevTime) => prevTime - 1);
      }, 1000);
    } else if (remainingTime === 0) {
      setIsResendEnabled(true);
    }

    return () => {
      clearInterval(timerInterval);
    };
  }, [remainingTime]);

  return (
    <>
      <div className="card-body pt-0">
        <h3 className="text-center mt-4">
          <a href="/" className="logo logo-admin">
            <img src={Logo} height="100" alt="logo" className=" mb-4" style={{ width: "220px" }} />
          </a>
          <div className="d-flex align-items-center justify-content-start">
            <img src={leftIcon} alt="logo" onClick={() => navigate(-1)} />{" "}
            <h3 className="ps-5 ms-3 mb-0">{title}</h3>
          </div>
          {/* <p className="sub-title">
            Please enter the verification code sent to your registered email id.
          </p> */}
        </h3>
        <div className="login-container">
          <img src={check} alt="check" className="d-flex mx-auto w-50 h-50" />

          <p className="text-center pt-3" style={{ fontSize: "18px" }}>
            {subTitle}
          </p>
          <button
            type="submit"
            className="sign-in-button mb-3 w-100"
            // onClick={onVerifyAction}
            onClick={() => navigate(type === "signup" ? "dashboard" : "/")}
            disabled={loader}
          >
            {loader ? "Please wait..." : btnName}
          </button>
        </div>
      </div>
    </>
  );
};

export default SuccessfullCard;
